import { render } from "./BaseColour.vue?vue&type=template&id=84f8c38c"
import script from "./BaseColour.vue?vue&type=script&lang=js"
export * from "./BaseColour.vue?vue&type=script&lang=js"

import "./BaseColour.vue?vue&type=style&index=0&id=84f8c38c&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__